import { ADD_PACKAGE, DELETE_PACKAGE, GET_PACKAGES, GET_WITHOUT_PERMISSION_PACKAGES, UPDATE_PACKAGE, UPDATE_PACKAGE_STATUS } from "../types";


const initialState = {list: [], single: null, cities: []};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case GET_PACKAGES:
            return {...state, list: payload};
   
        // case GET_WITHOUT_PERMISSION_PACKAGES:
            
        //     return {...state, list: payload};

        case UPDATE_PACKAGE:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload.id ? payload : item
                ),
            };
        
        case UPDATE_PACKAGE_STATUS:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload.id ? payload : item
                ),
            };

        case ADD_PACKAGE:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case DELETE_PACKAGE:
            return {
                ...state,
                list: state.list.filter((item) => item.id !== payload.id),
            };

        default:
            return state;
    }
};

export default reducer;
